import { render, staticRenderFns } from "./JomBantuDoc.vue?vue&type=template&id=c7438ffc&"
import script from "./JomBantuDoc.vue?vue&type=script&lang=js&"
export * from "./JomBantuDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports